var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-certification"},[_c('edit-table',{attrs:{"option":_vm.option,"data":_vm.salaryData},on:{"submit-add":_vm.handleSubmit,"submit-edit":_vm.handleSubmit,"refresh-change":_vm.refreshChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }